import React, { FC } from 'react';
import { ResetPageContainer } from './reset-container.component';
import { ResetEmailForm } from './reset-email-form.component';

interface IProps {}

export const ResetEmailPage: FC<IProps> = () => (
  <ResetPageContainer>
    <ResetEmailForm />
  </ResetPageContainer>
);
